<template>
  <div class="relative min-h-screen">
    <div class="h-80 bg-bgheader w-full absolute top-0 left-0 z-0"></div>
    <div class="relative z-10 pt-10 pb-10">
      <div class="p-3 max-w-md mx-2">
        <!-- تاریخ -->
        <custom-date-picker v-model="date" class="w-full"></custom-date-picker>

        <!-- لیست سفارشات -->
        <div
          v-for="order in orders"
          :key="order.id"
          @click="selectOrder(order.id)"
          class="w-full bg-white rounded-2xl px-4 py-6 border text-cyan-900 text-sm mt-4 mb-4 shadow-lg cursor-pointer"
        >
          <!-- هر ردیف اطلاعات با grid 2 ستونه -->
          <div class="grid grid-cols-[30px_1fr] gap-2 mb-2 items-center">
            <font-awesome-icon icon="circle-user" class="fa-xl text-bgbutton" />
            <div class="flex gap-1">
              <span class="font-bold">نام : </span>
              <span>{{ order.customerName }}</span>
            </div>
          </div>

          <div class="grid grid-cols-[30px_1fr] gap-2 mb-2 items-center">
            <font-awesome-icon
              icon="calendar-days"
              class="fa-xl text-bgbutton"
            />
            <div class="flex gap-1">
              <span class="font-bold">تاریخ : </span>
              <span>{{ order.pBasketDate }}</span>
            </div>
          </div>

          <div class="grid grid-cols-[30px_1fr] gap-2 mb-2 items-center">
            <font-awesome-icon icon="hashtag" class="fa-xl text-bgbutton" />
            <div class="flex gap-1">
              <span class="font-bold">شماره مشتری : </span>
              <span>{{ order.customerId }}</span>
            </div>
          </div>

          <div class="grid grid-cols-[30px_1fr] gap-2 mb-2 items-center">
            <font-awesome-icon
              icon="arrows-rotate"
              class="fa-xl text-bgbutton"
            />
            <div class="flex gap-1">
              <span class="font-bold">وضعیت مشتری : </span>
              <span>{{ order.basketStatus_Name }}</span>
            </div>
          </div>

          <div class="grid grid-cols-[30px_1fr] gap-2 items-center">
            <font-awesome-icon
              icon="fa-solid fa-sack-dollar"
              class="fa-xl text-bgbutton"
            />
            <div class="flex gap-1">
              <span class="font-bold">مبلغ نهایی :</span>
              <span>{{
                $helper.priceFormatter(order.totalPrice_AfterTax / 10)
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="orders.length > 5">
      <v-pagination
        v-model="pagination.pageNumber"
        :pages="pagination.totalPages"
        :range-size="1"
        active-color=""
        @update:modelValue="getOrders"
      />
    </div>
  </div>
</template>
<script>
import { getOrders } from "@/API/API";
import VPagination from "@hennge/vue3-pagination";
import "../../assets/css/pagination.css";
import jalaali from "jalaali-js";
export default {
  name: "ReportPage",
  components: { VPagination },
  data() {
    return {
      requests: [],
      pagination: {},
      orders: [],
      date: "",
      pageNumber: 1,
    };
  },
  mounted() {
    const pDate = this.getPersianDate();
    this.date = pDate;
  },
  async created() {
    this.getOrders(this.pageNumber);
  },
  methods: {
    async getOrders(pageNumber) {
      this.requests = (await getOrders(pageNumber, this.date)).data.result;
      console.log(this.requests);
      this.orders = [];
      this.orders = this.requests.orders;
      this.pagination = {};
      this.pagination = this.requests.pagination;
    },
    selectOrder(id) {
      this.$router.push(`/repeatfactor/${id}`);
    },
    getPersianDate() {
      const currentDate = new Date(); // تاریخ جاری میلادی
      const jalaaliDate = jalaali.toJalaali(currentDate); // تبدیل به شمسی

      const year = jalaaliDate.jy; // سال شمسی
      const month = String(jalaaliDate.jm).padStart(2, "0"); // ماه شمسی
      const day = String(jalaaliDate.jd).padStart(2, "0"); // روز شمسی

      return `${year}/${month}/${day}`;
    },
  },
  watch: {
    date(newDate) {
      // هر بار تاریخ تغییر کرد، getOrders صدا زده شود
      this.getOrders(this.pageNumber, newDate);
    },
  },
};
</script>
